import { PropsWithChildren, ReactNode } from 'react';

import { DialogFooterV2, Inset, Stack } from '@cast/design-system';

type DialogFeedbackLayoutProps = PropsWithChildren<{
  variant?: 'success' | 'error';
  actions?: ReactNode;
}>;

export const DialogFeedbackLayout = ({
  variant,
  children,
  actions,
}: DialogFeedbackLayoutProps) => {
  return (
    <Stack
      data-testid={
        variant === 'success' ? 'feedback-success' : 'feedback-failure'
      }
    >
      <Inset my={24}>{children}</Inset>
      <DialogFooterV2 endContent={actions} divider />
    </Stack>
  );
};
